import {h, Fragment} from "preact"
import { useEffect, useState, useRef } from "preact/hooks";

export default function CustomDropdown({ value, handleChange, options, label, title }) {
    const [ open, setOpen ] = useState(false);
    const dropdownRef = useRef(null);
    const toggleRef = useRef(null);

    useEffect(() => { // close dropdown on outside clicks
        const handleClick = (event) => {
            if(
                event.target.classList.contains('ns-dropdown-label') ||
                (
                    !dropdownRef.current.contains(event.target) && 
                    !toggleRef.current.contains(event.target)
                )
            ) {
                // blur to avoid aria console errors
                dropdownRef.current.blur();
                dropdownRef.current.querySelectorAll("*").forEach(el => el.blur);
                setOpen(false);
            };
        };

        if(open && dropdownRef?.current && toggleRef?.current) {
            window.document.addEventListener('click', handleClick);
        };
        return () => window.document.removeEventListener('click', handleClick);
    }, [ open ]);

    const toggleSort = () => {
        setOpen(prevOpen => !prevOpen);
    };

    return (
        <div class="ns-dropdown ns-relative">
            <button 
                type="button"
                class="ns-toolbar-btn ns-flex ns-items-center ns-flex-nowrap"
                aria-haspopup="listbox"
                aria-controls={`ns-dropdown-content-${label}`}
                aria-labelledby={`ns-header-${label}`}
                aria-expanded={open}
                onClick={toggleSort}
                ref={toggleRef}
            >
                <h4 id={`ns-header-${label}`} class="ns-toolbar-btn-text">
                    {title || label}
                </h4>
                <svg class="ns-lg-hidden" aria-hidden="true" role="presentation" focusable="false" width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.5 0.75L5 6L9.5 0.75" stroke="black" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="ns-hidden ns-lg-block ns-plus-minus-icon" aria-hidden="true" role="presentation" focusable="false" />
            </button>
            
            <div
                class="ns-custom-dropdown ns-absolute"
                id={`ns-dropdown-content-${label}`}
                aria-hidden={!open}
                ref={dropdownRef}
            >
                <fieldset
                    onChange={e => {
                        e.preventDefault();
                        handleChange(e.target.value);
                    }}
                >
                    <legend class="sr-only visually-hidden">{title || label}</legend>
                    <ul class="ns-custom-dropdown-list ns-flex ns-flex-col ns-list-unstyled" role="listbox">
                        {options.map(option => {
                            const optionLabel = option.label.toLowerCase().replaceAll(' ', '-');
                            return (
                                <li
                                    key={option.value}
                                    class="ns-dropdown-listitem"
                                    role="option"
                                >
                                    <label 
                                        htmlFor={`ns-${label}-${optionLabel}`}
                                        class="ns-dropdown-label ns-clickable ns-flex ns-flex-nowrap ns-items-center"
                                    >
                                        <input
                                            class="ns-custom-dropdown-input sr-only visually-hidden"
                                            type="radio"
                                            id={`ns-${label}-${optionLabel}`}
                                            value={option.value}
                                            checked={value === option.value}
                                            name={`dropdown-option-${label}`}
                                        />
                                        <span aria-hidden="true" role="presentation" class="ns-dropdown-checkmark ns-block" />
                                        <span>{option.label}</span>
                                    </label>
                                </li>
                            )
                        })}
                    </ul>
                </fieldset>
            </div>
        </div>
    )
}